import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    load: true,
    loader: true,
    hints: true,
    popups: [],
    drawerListActive: false,
    sideHeroActive: false,
    activeItemSidebar: null,
  },
  mutations: {
    setLoad(state, payload) {
      state.loader = payload;
    },
    setSourceLoadState(state, payload) {
      state.load = payload;
    },
    setSelectedItem(state, payload) {
      state.activeItemSidebar = payload;
    },
    setHints(state, payload) {
      state.hints = payload;
    },
    setSidebar(state, payload) {
      state.sideHeroActive = payload;
    },
    setDrawer(state, payload) {
      state.drawerListActive = payload;
    },
    setLoadedPopups(state, payload) {
      state.popups = payload;
    },
  },
  actions: {},
  modules: {},
});
